import React, { useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { S3, S3_BUCKET, EditorOptions } from "./../../../resources/config";

// Components
import MuiHeader from "../../../components/MuiHeader";
import MuiLoader from "../../../components/MuiLoader";
import ProgressStatus from "./../../../components/ProgressStatus";

import {
  Button,
  Grid,
  Paper,
  TextField,
  experimentalStyled as styled,
} from "@mui/material";

import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "left",
  color: theme.palette.text.secondary,
}));

function DemoTemplate() {
  // ---- Load Query string parameters ----
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const stringifiedParams = searchParams.get("params");
  const params = JSON.parse(stringifiedParams);
  console.log("==> params", params);
  // ---------------------------------------
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  // --- TEXT ----
  //const editor1Ref = useRef();
  const [editor1Content, setEditor1Content] = useState("");
  const editor1_on_change = (content) => {
    setEditor1Content(content);
  };

  const [editor2Content, setEditor2Content] = useState("");
  const editor2_on_change = (content) => {
    setEditor2Content(content);
  };

  const [editor3Content, setEditor3Content] = useState("");
  const editor3_on_change = (content) => {
    setEditor3Content(content);
  };

  const [editor4Content, setEditor4Content] = useState("");
  const editor4_on_change = (content) => {
    setEditor4Content(content);
  };
  // ----------------

  // ----- FILE -----
  const image1Ref = useRef();
  const previewImage1 = useRef();
  const [showPreviewImage1, setShowPreviewFile1] = useState(false);
  const [image1Url, setFile1Url] = useState(null);
  const [image1_preview_html, setImage1_preview_html] = useState(null);
  const image1_on_change = async (event) => {
    await upload_file_to_s3(
      event.target.files[0],
      "file1",
      event.target.files[0].type
    );
  };
  const image1_on_delete = async (fileUrl, position) => {
    // get file name from image url
    const parsedUrl = new URL(fileUrl);
    const path = parsedUrl.pathname;
    const segments = path.split("/");
    const filename = segments[segments.length - 1];
    console.log("-->filename: ", filename);
    await delete_file_from_s3(filename, position);
  };

  const video1Ref = useRef();
  const previewVideo1 = useRef();
  const [showPreviewVideo1, setShowPreviewFile2] = useState(false);
  const [video1Url, setFile2Url] = useState(null);
  const [video1_preview_html, setVideo1_preview_html] = useState(null);
  const video1_on_change = async (event) => {
    await upload_file_to_s3(
      event.target.files[0],
      "video1",
      event.target.files[0].type
    );
  };
  const video1_on_delete = async (fileurl, position) => {
    // get file name from image url
    const parsedUrl = new URL(fileurl);
    const path = parsedUrl.pathname;
    const segments = path.split("/");
    const filename = segments[segments.length - 1];
    console.log("-->filename: ", filename);
    await delete_file_from_s3(filename, position);
  };

  const audeo1Ref = useRef();
  const previewAudio1 = useRef();
  const [showPreviewAudio1, setShowPreviewFile3] = useState(false);
  const [audio1Url, setFile3Url] = useState(null);
  const [audio1_preview_html, setAudio1_preview_html] = useState(null);
  const audio1_on_change = async (event) => {
    console.log("audio--->", event.target.files);
    await upload_file_to_s3(
      event.target.files[0],
      "audio1",
      event.target.files[0].type
    );
  };
  const audio1_on_delete = async (fileUrl, position) => {
    // get file name from image url
    const parsedUrl = new URL(fileUrl);
    const path = parsedUrl.pathname;
    const segments = path.split("/");
    const filename = segments[segments.length - 1];
    console.log("-->filename: ", filename);
    await delete_file_from_s3(filename, position);
  };
  // --------------------

  // --- UPLOAD TO S3 ---
  const upload_file_to_s3 = async (file, position, contenttype) => {
    setLoading(true);
    setProgress(0);

    const params = {
      ACL: "public-read",
      Bucket: S3_BUCKET,
      //Key: file.name,
      Key: "" + new Date().getTime(),
      Body: file,
      ContentType: contenttype,
    };

    const request = await S3.putObject(params);

    request.on("httpUploadProgress", (evt) => {
      setProgress(Math.round((evt.loaded / evt.total) * 100));
    });

    request.send(async (err, data) => {
      if (err) {
        console.log("Error uploading file:", err);
      } else {
        console.log("File uploaded successfully:", data);
        const url = `https://${params.Bucket}.S3.${S3.config.region}.amazonaws.com/${params.Key}`;

        if (position === "file1") {
          setFile1Url(url);
          setImage1_preview_html(` <img src=${url} width="90%" />`);
          setShowPreviewFile1(true);
        } else if (position === "video1") {
          setFile2Url(url);
          setVideo1_preview_html(` <video controls width="90%">
                <source src=${url} type="video/mp4" />
              </video>`);
          setShowPreviewFile2(true);
        } else if (position === "audio1") {
          setFile3Url(url);
          setAudio1_preview_html(` <audio controls width="90%">
                <source src=${url} type="audio/mpeg" />
              </audio>`);
          setShowPreviewFile3(true);
        }
        setLoading(false);
        setProgress(0);
      }
    });
  };
  // ----------------------

  // --- DELETE FROM S3 ---
  const delete_file_from_s3 = async (filename, position) => {
    setLoading(true);
    setProgress(0);

    const params = {
      Bucket: S3_BUCKET,
      Key: filename,
    };

    await S3.deleteObject(params, async (err, data) => {
      if (err) {
        alert("Error deleting file:" + err);
      } else {
        setLoading(false);
        console.log("File deleted successfully:" + filename);

        if (position === "file1") {
          setFile1Url(null);
          image1Ref.current.value = "";
          setShowPreviewFile1(false);
        } else if (position === "video1") {
          setFile2Url(null);
          video1Ref.current.value = "";
          setShowPreviewFile2(false);
        } else if (position === "audio1") {
          setFile3Url(null);
          audeo1Ref.current.value = "";
          setShowPreviewFile3(false);
        }
      }
    });
  };
  // ---------------------
  const [output, setOutput] = useState({});
  const save_template_button_click = () => {
    const template_obj = {
      fragment1: {
        type: "text",
        value: editor1Content,
      },
      fragment2: {
        type: "image",
        value: image1Url,
      },
      fragment3: {
        type: "text",
        value: editor2Content,
      },
      fragment4: {
        type: "video",
        value: video1Url,
      },
      fragment5: {
        type: "text",
        value: editor3Content,
      },
      fragment6: {
        type: "audio",
        value: audio1Url,
      },
      fragment7: {
        type: "text",
        value: editor4Content,
      },
    };
    setOutput(template_obj);
    console.log("save clicked: ", template_obj);
  };

  return (
    <>
      <div>
        <h2>Demo Template</h2>

        {/* Fragment-1 TEXT */}
        <h2>Attach Text</h2>
        <div className="editor_width">
          <SunEditor
            height="200px"
            defaultValue={editor1Content}
            onChange={editor1_on_change}
            setOptions={EditorOptions}
          />
        </div>

        {/* Fragment-2 IMAGE */}
        <h2>Attach Image</h2>
        <div>
          <div
            style={{ display: showPreviewImage1 ? "none" : "block" }}
            className="vidimg_frame"
          >
            <input
              type="file"
              accept="image/*"
              onChange={image1_on_change}
              ref={image1Ref}
            />
          </div>
          <div
            ref={previewImage1}
            style={{ display: !showPreviewImage1 ? "none" : "block" }}
          >
            <div className="delete_media_button">
              <Button onClick={() => image1_on_delete(image1Url, "file1")}>
                Delete
              </Button>
            </div>

            <div
              className="vidimg_frame"
              dangerouslySetInnerHTML={{ __html: image1_preview_html }}
            ></div>
          </div>
        </div>

        {/* Fragment-3 TEXT */}
        <h2>Attach Text</h2>
        <div className="editor_width">
          <SunEditor
            height="200px"
            defaultValue={editor2Content}
            onChange={editor2_on_change}
            setOptions={EditorOptions}
          />
        </div>

        {/* Fragment-4 VIDEO */}
        <h2>Attach Video</h2>
        <div>
          <div
            style={{ display: showPreviewVideo1 ? "none" : "block" }}
            className="vidimg_frame"
          >
            <input
              type="file"
              accept="video/*"
              onChange={video1_on_change}
              ref={video1Ref}
            />
          </div>
          <div
            ref={previewVideo1}
            style={{ display: !showPreviewVideo1 ? "none" : "block" }}
          >
            <div className="delete_media_button">
              <Button onClick={() => video1_on_delete(video1Url, "video1")}>
                Delete
              </Button>
            </div>

            <div
              className="vidimg_frame"
              dangerouslySetInnerHTML={{ __html: video1_preview_html }}
            ></div>
          </div>
        </div>

        {/* Fragment-5 TEXT */}
        <h2>Attach Text</h2>
        <div className="editor_width">
          <SunEditor
            height="200px"
            defaultValue={editor3Content}
            onChange={editor3_on_change}
            setOptions={EditorOptions}
          />
        </div>

        {/* Fragment-6 AUDIO */}
        <h2>Attach Audio</h2>
        <div>
          <div
            style={{ display: showPreviewAudio1 ? "none" : "block" }}
            className="vidimg_frame"
          >
            <input
              type="file"
              accept="audio/*"
              onChange={audio1_on_change}
              ref={audeo1Ref}
            />
          </div>
          <div
            ref={previewAudio1}
            style={{ display: !showPreviewAudio1 ? "none" : "block" }}
          >
            <div className="delete_media_button">
              <Button onClick={() => audio1_on_delete(audio1Url, "audio1")}>
                Delete
              </Button>
            </div>

            <div
              className="vidimg_frame"
              dangerouslySetInnerHTML={{ __html: audio1_preview_html }}
            ></div>
          </div>
        </div>

        {/* Fragment-7 TEXT */}
        <h2>Attach Text</h2>
        <div className="editor_width">
          <SunEditor
            height="200px"
            defaultValue={editor4Content}
            onChange={editor4_on_change}
            setOptions={EditorOptions}
          />
        </div>

        {/* Save */}
        <div className="save_div">
          <Button onClick={save_template_button_click} className="save_button">
            Save
          </Button>
        </div>
      </div>

      {/* Progress */}
      <ProgressStatus open={loading} text={progress} />

      {/* Preview */}
      {Object.keys(output).length > 0 && (
        <>
          <div className="preview_outerdiv">
            <h1>Preview</h1>
          </div>
          <div className="preview_outerdiv">
            <div className="preview_innerdiv">
              {output.hasOwnProperty("fragment1") &&
                Object.keys(output.fragment1).length > 0 && (
                  <div>
                    {output.fragment1.type === "text" && (
                      <div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: output.fragment1.value,
                          }}
                        ></div>
                      </div>
                    )}
                    {output.fragment1.type === "image" && (
                      <div className="media_div">
                        <img src={output.fragment1.value} />
                      </div>
                    )}
                    {output.fragment1.type === "video" && (
                      <div className="media_div">
                        <video controls>
                          <source src={output.fragment1.value} />
                        </video>
                      </div>
                    )}
                    {output.fragment1.type === "audio" && (
                      <div className="media_div">
                        <audio controls>
                          <source src={output.fragment1.value} />
                        </audio>
                      </div>
                    )}
                  </div>
                )}

              {output.hasOwnProperty("fragment2") &&
                Object.keys(output.fragment2).length > 0 && (
                  <div>
                    {output.fragment2.type === "text" && (
                      <div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: output.fragment2.value,
                          }}
                        ></div>
                      </div>
                    )}
                    {output.fragment2.type === "image" && (
                      <div className="media_div">
                        <img src={output.fragment2.value} />
                      </div>
                    )}
                    {output.fragment2.type === "video" && (
                      <div className="media_div">
                        <video controls>
                          <source src={output.fragment2.value} />
                        </video>
                      </div>
                    )}
                    {output.fragment2.type === "audio" && (
                      <div className="media_div">
                        <audio controls>
                          <source src={output.fragment2.value} />
                        </audio>
                      </div>
                    )}
                  </div>
                )}

              {output.hasOwnProperty("fragment3") &&
                Object.keys(output.fragment3).length > 0 && (
                  <div>
                    {output.fragment3.type === "text" && (
                      <div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: output.fragment3.value,
                          }}
                        ></div>
                      </div>
                    )}
                    {output.fragment3.type === "image" && (
                      <div className="media_div">
                        <img src={output.fragment3.value} />
                      </div>
                    )}
                    {output.fragment3.type === "video" && (
                      <div className="media_div">
                        <video controls>
                          <source src={output.fragment3.value} />
                        </video>
                      </div>
                    )}
                    {output.fragment3.type === "audio" && (
                      <div className="media_div">
                        <audio controls>
                          <source src={output.fragment3.value} />
                        </audio>
                      </div>
                    )}
                  </div>
                )}

              {output.hasOwnProperty("fragment4") &&
                Object.keys(output.fragment4).length > 0 && (
                  <div>
                    {output.fragment4.type === "text" && (
                      <div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: output.fragment4.value,
                          }}
                        ></div>
                      </div>
                    )}
                    {output.fragment4.type === "image" && (
                      <div className="media_div">
                        <img src={output.fragment4.value} />
                      </div>
                    )}
                    {output.fragment4.type === "video" && (
                      <div className="media_div">
                        <video controls>
                          <source src={output.fragment4.value} />
                        </video>
                      </div>
                    )}
                    {output.fragment4.type === "audio" && (
                      <div className="media_div">
                        <audio controls>
                          <source src={output.fragment4.value} />
                        </audio>
                      </div>
                    )}
                  </div>
                )}

              {output.hasOwnProperty("fragment5") &&
                Object.keys(output.fragment5).length > 0 && (
                  <div>
                    {output.fragment5.type === "text" && (
                      <div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: output.fragment5.value,
                          }}
                        ></div>
                      </div>
                    )}
                    {output.fragment5.type === "image" && (
                      <div className="media_div">
                        <img src={output.fragment5.value} />
                      </div>
                    )}
                    {output.fragment5.type === "video" && (
                      <div className="media_div">
                        <video controls>
                          <source src={output.fragment5.value} />
                        </video>
                      </div>
                    )}
                    {output.fragment5.type === "audio" && (
                      <div className="media_div">
                        <audio controls>
                          <source src={output.fragment5.value} />
                        </audio>
                      </div>
                    )}
                  </div>
                )}

              {output.hasOwnProperty("fragment6") &&
                Object.keys(output.fragment6).length > 0 && (
                  <div>
                    {output.fragment6.type === "text" && (
                      <div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: output.fragment6.value,
                          }}
                        ></div>
                      </div>
                    )}
                    {output.fragment6.type === "image" && (
                      <div className="media_div">
                        <img src={output.fragment6.value} />
                      </div>
                    )}
                    {output.fragment6.type === "video" && (
                      <div className="media_div">
                        <video controls>
                          <source src={output.fragment6.value} />
                        </video>
                      </div>
                    )}
                    {output.fragment6.type === "audio" && (
                      <div className="media_div">
                        <audio controls>
                          <source src={output.fragment6.value} />
                        </audio>
                      </div>
                    )}
                  </div>
                )}

              {output.hasOwnProperty("fragment7") &&
                Object.keys(output.fragment7).length > 0 && (
                  <div>
                    {output.fragment7.type === "text" && (
                      <div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: output.fragment7.value,
                          }}
                        ></div>
                      </div>
                    )}
                    {output.fragment7.type === "image" && (
                      <div className="media_div">
                        <img src={output.fragment7.value} />
                      </div>
                    )}
                    {output.fragment7.type === "video" && (
                      <div className="media_div">
                        <video controls>
                          <source src={output.fragment7.value} />
                        </video>
                      </div>
                    )}
                    {output.fragment7.type === "audio" && (
                      <div className="media_div">
                        <audio controls>
                          <source src={output.fragment7.value} />
                        </audio>
                      </div>
                    )}
                  </div>
                )}

              {output.hasOwnProperty("fragment8") &&
                Object.keys(output.fragment8).length > 0 && (
                  <div>
                    {output.fragment8.type === "text" && (
                      <div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: output.fragment8.value,
                          }}
                        ></div>
                      </div>
                    )}
                    {output.fragment8.type === "image" && (
                      <div className="media_div">
                        <img src={output.fragment8.value} />
                      </div>
                    )}
                    {output.fragment8.type === "video" && (
                      <div className="media_div">
                        <video controls>
                          <source src={output.fragment8.value} />
                        </video>
                      </div>
                    )}
                    {output.fragment8.type === "audio" && (
                      <div className="media_div">
                        <audio controls>
                          <source src={output.fragment8.value} />
                        </audio>
                      </div>
                    )}
                  </div>
                )}
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default DemoTemplate;
